import React from 'react';
import { Briefcase, CalendarDays, CalendarClock, Euro } from '../../../../shared/assets/AppIcons';
import DealsStatsGrid from '@/modules/deals/components/shared/DealsStatsGrid';

const COMPLETED_STATS_CONFIG = [
  {
    key: 'thisWeek',
    title: 'Questa settimana',
    tone: 'neutral',
    icon: CalendarDays,
    cardClass: 'border-[var(--border)] bg-gradient-to-br from-[var(--success)] to-[var(--chart-accent-2)]',
    iconWrapClass: 'bg-[var(--success-soft)]',
    iconClass: 'text-[var(--success-text)]',
    titleClass: 'text-[var(--success-text)]',
    valueClass: 'text-[var(--success-text)]',
    description: () => 'storico visibile',
  },
  {
    key: 'volume',
    title: 'Volume',
    tone: 'success',
    icon: Euro,
    format: 'currency',
  },
  {
    key: 'total',
    title: 'Totale',
    tone: 'neutral',
    icon: Briefcase,
  },
  {
    key: 'overdue',
    title: 'Scadute',
    tone: 'attention',
    icon: CalendarClock,
  },
];

const CompletedStats = ({ stats, activeMetric, onMetricClick }) => (
  <DealsStatsGrid
    items={COMPLETED_STATS_CONFIG}
    stats={stats}
    activeMetric={activeMetric}
    onMetricClick={onMetricClick}
  />
);

export default CompletedStats;
